import { DayEntry } from '../types';

export const calculateCheckboxCompletion = (entries: DayEntry[], totalDays: number): number => {
  const completed = entries.filter(e => e.completed).length;
  return totalDays > 0 ? Math.round((completed / totalDays) * 100) : 0;
};

export const calculateRatingAverage = (entries: DayEntry[]): number => {
  const rated = entries.filter(e => e.rating !== undefined && e.rating > 0);
  if (rated.length === 0) return 0;
  const sum = rated.reduce((acc, e) => acc + (e.rating || 0), 0);
  return Math.round((sum / rated.length) * 10) / 10;
};

export const calculateRatingPercentage = (entries: DayEntry[]): number => {
  const avg = calculateRatingAverage(entries);
  return Math.round((avg / 5) * 100);
};
